import React, { useContext, useEffect, useState } from "react";
import HeaderImg from "../components/HeaderImg";
import { Link } from "react-router-dom";
import { Context } from "../context/MainContext";
import {
  clearCart,
  updateCart,
  updateShippingDetails,
} from "../context/Action";
import CartItem from "../components/CartItem";
// import { countryList } from "../assets/data/countries";

const Cart = () => {
  const { cart, dispatch } = useContext(Context);
  const [cartMain, setCartMain] = useState(null);
  const [method, setMethod] = useState("pickup");
  // const [methodAmount, setMethodAmount] = useState(0);
  const [total, setTotal] = useState(0);
  const [cartUpdated, setcartUpdated] = useState(false);
  const [country, setCountry] = useState("United States");

  const formattingOption = {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 2,
  };

  const handleRemoveFromCart = (id) => {
    const newCart = cartMain.filter((product) => product.id !== id);
    dispatch(updateCart(newCart));
  };

  const handleProceed = () => {
    const shippingdetails = {
      country,
      // methodAmount,
      method,
    };

    dispatch(updateShippingDetails(shippingdetails));
    dispatch(updateCart(cartMain));
  };

  useEffect(() => {
    setCartMain(cart);
  }, [cart, cart?.length]);

  useEffect(() => {
    if (cartMain) {
      let newTotal = 0;
      cartMain.forEach((product) => {
        newTotal += product.price * product.quantity;
      });

      setTotal(newTotal);
    } else setTotal(0);
  }, [cartMain, cartMain?.length, cartUpdated]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cart">
      <HeaderImg title="Cart" />

      <div className="cart__wrapper">
        <div className="cart__main">
          <div className="cart__main__clear">
            <button onClick={() => dispatch(clearCart())}>Clear cart</button>
          </div>
          <div className="cart__main__product">
            {cartMain?.map((product, i) => {
              return (
                <CartItem
                  key={product.id}
                  product={product}
                  handleRemoveFromCart={handleRemoveFromCart}
                  setCartMain={setCartMain}
                  setcartUpdated={setcartUpdated}
                  index={i}
                  cartMain={cartMain}
                />
              );
            })}
          </div>

          <h2 className="cart__main__total__title">Cart totals</h2>
          <div className="cart__main__total">
            <div className="cart__main__total__part">
              <b>Subtotal:</b> {total.toLocaleString("en-NG", formattingOption)}
            </div>
            <div className="cart__main__total__part shipping">
              <b>Delivery:</b>{" "}
              <div className="cart__main__total__part__inputs">
                <div className="cart__main__total__part__inputs__item">
                  <input
                    type="radio"
                    id="pickup"
                    value="pickup"
                    name="method"
                    checked={method === "pickup"}
                    onChange={(e) => setMethod(e.target.value)}
                  />{" "}
                  <label htmlFor="pickup">Pickup : ₦00.00</label>
                </div>
                <div className="cart__main__total__part__inputs__item">
                  <input
                    type="radio"
                    id="delivery"
                    value="delivery"
                    name="method"
                    checked={method === "delivery"}
                    onChange={(e) => setMethod(e.target.value)}
                  />{" "}
                  <label htmlFor="delivery">Delivery : Price varies</label>
                </div>

                {method === "delivery" && (
                  <p style={{ maxWidth: 300 }}>
                    Note: Delivery fees are calculated based on the weight of
                    your item(s) and your delivery address. The exact fee will
                    be communicated once your order has been confirmed.
                  </p>
                )}
              </div>
            </div>

            <div className="cart__main__total__part">
              <b>Total:</b> {total?.toLocaleString("en-NG", formattingOption)}
            </div>
          </div>

          {cart?.length > 0 && (
            <div className="cart__main__btn">
              <Link to="/checkout">
                <button onClick={handleProceed}>Proceed to checkout</button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Cart;
